import { action, makeObservable, observable } from 'mobx';

import ApiService from '../services/ApiService';

import { ILanguageStore } from './LanguageStore';
import { CurrentBalances, ProductBalance } from './models/CurrentBalances';
import { Loadable } from './models/Loadable';
import { ISsoStore } from './SsoStore';

export default class CurrentBalancesStore {
  @observable
  public currentBalances: Loadable<CurrentBalances> = new Loadable<CurrentBalances>();

  constructor(
    private apiService: ApiService,
    private ssoStore: ISsoStore,
    private languageStore: ILanguageStore
  ) {
    makeObservable(this);
  }

  @action
  public async tryLoadCurrentBalances(): Promise<void> {
    if (!this.currentBalances.isInitial) {
      await this.currentBalances.promise;
      return;
    }
    const currentBalancesPromise = this.apiService.getCurrentBalances(this.ssoStore.customer.customerId);
    this.currentBalances = Loadable.toLoadable(currentBalancesPromise);
    await currentBalancesPromise;
  }

  public getProductName(productBalance: ProductBalance): string {
    return this.languageStore.currentLanguage === 'ru' ? productBalance.name.russian : productBalance.name.estonian;
  }

  public getProductDescription(productBalance: ProductBalance): string {
    return productBalance.address || this.getStringFromPhoneNumbers(productBalance.phoneNumbers);
  }

  private getStringFromPhoneNumbers(phoneNumbers: string[]): string {
    let phoneNumberString = '';
    const visiblePhoneNumbers = phoneNumbers.slice(0, 4);
    visiblePhoneNumbers.forEach((phoneNumber) => (phoneNumberString = `${phoneNumberString + phoneNumber}, `));
    phoneNumberString = phoneNumberString.trim();
    phoneNumberString = phoneNumberString.substring(0, phoneNumberString.length - 1);
    if (phoneNumbers.length > 4) {
      phoneNumberString = `${phoneNumberString} ...`;
    }
    return phoneNumberString;
  }
}
